/* var(--color-easil-gray-dark) is used on the JSX */

.cell {
  flex: 1 0 auto;
  width: 25%;
  overflow: hidden;
}

.cell:nth-child(4n + 2) {
  width: 40%;
}

.cell:nth-child(4n) {
  width: 10%;
  display: flex;
  justify-content: flex-end;
}

.header {
  color: var(--color-easil-black);
  display: flex;
  flex: 1 0 100%;
  flex-wrap: wrap;
  padding-bottom: 25px;
}

.row {
  font-size: 14px;
  display: flex;
  flex: 1 0 100%;
  flex-wrap: wrap;
  padding-top: 28px;
}

.table {
  display: flex;
  flex: 1 0 100%;
  flex-wrap: wrap;
  color: var(--color-easil-gray-x-dark);
  position: relative;
}
